<template>
  <WorkerColumn
    :worker-id="column.worker.id"
    :name="column.worker.name"
    :email="column.worker.email"
    :avatar="column.worker.avatar"
    :initials="column.worker.initials"
    :employment-id="column.id"
    show-avatar
    show-email
  />
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { FragmentType, graphql, useFragment } from '@/gql'
import WorkerColumn from '@/components/GraphqlDataTable/columns/WorkerColumn.vue'

const EmploymentWorkerColumn = graphql(`
  fragment EmploymentWorkerColumn on Employment {
    id
    worker {
      id
      name
      email
      avatar
      initials
    }
  }
`)

const props = defineProps<{ row: FragmentType<typeof EmploymentWorkerColumn> }>()
const column = computed(() => useFragment(EmploymentWorkerColumn, props.row))
</script>
